import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsAntePostMarketWidget" */ './SportsAntePostMarketWidget'),
  modules: ['./SportsAntePostMarketWidget'],
  loading: () => <div />
});

export default LoadableWidget;
